import { Mesh, Observer, PointerEventTypes, PointerInfo, Scene, Vector3 } from 'babylonjs';

export interface TapInfo {
  mesh: Mesh;
  faceId: number;
  worldPoint: Vector3;
}

/**
 * Fires on a tap (not a drag) over a model mesh. Babylon's POINTERTAP already
 * debounces orbit drags; picking is filtered to meshes tagged `metadata.ejPlaneFinder`
 * so UI/helper meshes are ignored.
 */
export class TapPicker {
  private observer: Observer<PointerInfo> | null;

  constructor(
    private scene: Scene,
    private onTap: (tap: TapInfo) => void,
    private enabled: () => boolean,
  ) {
    this.observer = scene.onPointerObservable.add((pi) => {
      if (pi.type !== PointerEventTypes.POINTERTAP || !this.enabled()) return;
      // Prefer the tap's own pickInfo when it already hit a model mesh; otherwise
      // re-pick filtered to model meshes (e.g. the tap first hit the environment).
      let pick = pi.pickInfo;
      if (!pick?.hit || !pick.pickedMesh?.metadata?.ejPlaneFinder) {
        pick = this.scene.pick(this.scene.pointerX, this.scene.pointerY, (m) => Boolean(m.metadata?.ejPlaneFinder));
      }
      if (pick?.hit && pick.pickedMesh instanceof Mesh && pick.faceId >= 0 && pick.pickedPoint) {
        this.onTap({ mesh: pick.pickedMesh, faceId: pick.faceId, worldPoint: pick.pickedPoint });
      }
    });
  }

  dispose(): void {
    if (this.observer) {
      this.scene.onPointerObservable.remove(this.observer);
      this.observer = null;
    }
  }
}
